import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const CheckboxStyled = withStyles((theme) => ({
  root: {
    color: theme.palette.form.border,
    '&$checked': {
      color: theme.palette.primary.main,
    },
  },
  checked: {},
}))(Checkbox);

const FormControlLabelStyled = withStyles((theme) => ({
  root: {
    marginTop: 0,
    fontSize: theme.typography.appFontSize,
    '&.MuiFormControlLabel-root': {
      color: theme.palette.form.label,
      fontSize: theme.typography.appFontSize,
      marginLeft: 0,
      marginTop: 0,
      marginBottom: 10,

      '& span': {
        fontSize: theme.typography.appFontSize,
      },
    },
  },
}))(FormControlLabel);

export { CheckboxStyled, FormControlLabelStyled };
